import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import CampaignsPage from "@/pages/CampaignsPage";
import MomentMarketingPage from "@/pages/MomentMarketingPage";
import ContentPillarsPage from "@/pages/ContentPillarsPage";
import BroadcastPage from "@/pages/BroadcastPage";
import StorytellingPage from "@/pages/StorytellingPage";
import PlatformNativePage from "@/pages/PlatformNativePage";
import AudienceSegmentationPage from "@/pages/AudienceSegmentationPage";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/paid-organic-campaigns" element={<CampaignsPage />} />
          <Route path="/moment-marketing" element={<MomentMarketingPage />} />
          <Route path="/strategic-content-pillars" element={<ContentPillarsPage />} />
          <Route path="/broadcast-thought-leadership" element={<BroadcastPage />} />
          <Route path="/simplifying-finance-storytelling" element={<StorytellingPage />} />
          <Route path="/platform-native-strategies" element={<PlatformNativePage />} />
          <Route
            path="/audience-segmentation-data-driven"
            element={<AudienceSegmentationPage />}
          />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
